module.exports = __webpack_public_path__ + "img/user-default.d47c3a04.png";